<template>
    
    <div class="main">
        <MyHeader index="0"></MyHeader>
        
        
       <div id="myCarousel" class="carousel slide mb-6" data-bs-ride="carousel" style="margin-top:80px;">
		<div class="carousel-indicators">
		  <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="0" class="active" aria-label="Slide 1" aria-current="true"></button>
		  <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="1" aria-label="Slide 2" class=""></button>
		  <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="2" aria-label="Slide 3" class=""></button>
		   <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="3" aria-label="Slide 4" class=""></button>
		</div>
		<div class="carousel-inner" style="">
		  <div class="carousel-item active" style="">
			
			<img width="100%" height="100%" src="./image/a1.png" alt="">
			<div class="container">
			  <div class="carousel-caption text-start" style="left:7%;">
				<!--
				<h1>عنوان المثال.</h1>
				<p class="opacity-75">تشير الدراسات الإحصائية حسب الجمعية الأمريكية للغات بأن الإقبال على العربية زاد %126 في الولايات المتحدة الأمريكية وحدها بين عامي 2002 و2009م.</p>
				-->
				
				<p ><a class="btn btn-lg btn-primary" href="./aboutUs" style="font-size:18px;color:#ffffff;background: rgba(0, 0, 0, 0.2);border-radius:0px;border-color:transparent;">了解更多 <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 2 16 16">
  <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
</svg><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 2 16 16">
  <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
</svg></a></p>
			  </div>
			</div>
		  </div>
		  
		  <div class="carousel-item" style="">
			<img width="100%" height="100%" src="./image/a2.png" alt="">
			<div class="container">
			  <div class="carousel-caption text-start" style="left:7%;">
				<p ><a class="btn btn-lg btn-primary" href="./report/83" style="font-size:18px;color:#ffffff;background: rgba(0, 0, 0, 0.2);border-radius:0px;border-color:transparent;">了解更多 <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 2 16 16">
  <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
</svg><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 2 16 16">
  <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
</svg></a></p>
			  </div>
			</div>
		  </div>
		  <div class="carousel-item" style="">
			<img width="100%" height="100%" src="./image/a3.png" alt="">
			<div class="container">
			  <div class="carousel-caption text-start" style="left:7%;">
				<p ><a class="btn btn-lg btn-primary" href="./resources/76/1" style="font-size:18px;color:#ffffff;background: rgba(0, 0, 0, 0.2);border-radius:0px; border-style:solid;border-width:0px;background-color: rgba(255,255,255,0.2);">了解更多 <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 2 16 16">
  <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
</svg><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 2 16 16">
  <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
</svg></a></p>
			  </div>
			</div>
		  </div>
		  <div class="carousel-item" style="">
			<img width="100%" height="100%" src="./image/a4.png" alt="">
			<div class="container">
			  <div class="carousel-caption text-start" style="left:7%;">
				<p ><a class="btn btn-lg btn-primary" href="./news/70/1" style="font-size:18px;color:#ffffff;background: rgba(0, 0, 0, 0.2);border-radius:0px;border-color:transparent;">了解更多 <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 2 16 16">
  <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
</svg><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 2 16 16">
  <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
</svg></a></p>
			   </div>
			</div>
		  </div>
		  
		</div>
		<button class="carousel-control-prev" type="button" data-bs-target="#myCarousel" data-bs-slide="prev" style="width:9%;">
		  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
		  <span class="visually-hidden"></span>
		</button>
		<button class="carousel-control-next" type="button" data-bs-target="#myCarousel" data-bs-slide="next" style="width:9%;">
		  <span class="carousel-control-next-icon" aria-hidden="true"></span>
		  <span class="visually-hidden"></span>
		</button>
	  </div>
	  
	  
	  
        
        
        <div class="container">
            <div class="purpose">
                <div class="bigTitle">
                    <h2>{{$t('tit.title')}}</h2>
                </div>
                
                
                <div style="width: 534px;margin: 20px auto 0;margin-bottom:40px;font-size: 24px;font-weight:600;color: #999999;line-height: 25px;text-align: center;"  v-if=" this.$i18n.locale != 'zh_CN'">To achieve a world-class air quality in China and protect the climate by</div>
                <!--<h5 class="describe"  v-if=" this.$i18n.locale != 'zh_CN'">{{$t('txt.text01')}}</h5>-->
                <h5 class="describe" style="width: 395px" v-if=" this.$i18n.locale != 'zh_CN'">{{$t('txt.text')}}</h5>
                <h5 class="describe" v-if=" this.$i18n.locale == 'zh_CN'">{{$t('txt.text')}}</h5>
                <!--<h5 class="describe"  v-if=" this.$i18n.locale != 'zh_CN'">{{$t('txt.text02')}}</h5>-->
                <h5 class="describe" style="width: 484px" v-if=" this.$i18n.locale != 'zh_CN'">{{$t('txt.text21')}}</h5>
                <!--<h5 class="describe"  v-if=" this.$i18n.locale != 'zh_CN'">{{$t('txt.text03')}}</h5>-->
                <h5 class="describe"  v-if=" this.$i18n.locale != 'zh_CN'">{{$t('txt.text2')}}</h5>
          
                
                <div class="button">
                    <a :class="leftButton"  @click="leftRoll" style="margin-right: 24px;" href="javascript:void (0);">{{$t('label.title')}}</a>
                    <a :class="rightButton"  @click="rightRoll" href="javascript:void (0);">{{$t('label.title1')}}</a>
                </div>
                <div class="expert" v-if=" this.$i18n.locale == 'zh_CN'">
                    <span class="roll" @click="rollRight"></span>
                    <div class="expertList">
                        <ul :style="rollStyle" style="display: flex" v-if="figureType === 1">
                            <li v-for="item in expertList1" style="min-width: 220px">
                                <router-link :to="'/figureInfo/' + item.id">
                                    <div class="photo">
                                        <img :src="item.avatar" alt="photo">
                                    </div>
                                    <h3 class="name">{{item.name}}</h3>
                                    <h4 class="school">{{item.organization}}</h4>
                                    <h6 class="briefing" v-html="item.brief"></h6>
                                </router-link>
                            </li>
                        </ul>
                        <ul :style="rollStyle" v-if="figureType === 2">
                            <li v-for="item in expertList2">
                                <router-link :to="'/figureInfo/' + item.id">
                                    <div class="photo">
                                        <img :src="item.avatar" alt="photo">
                                    </div>
                                    <h3 class="name">{{item.name}}</h3>
                                    <h4 class="school">{{item.organization}}</h4>
                                    <h6 class="briefing" v-html="item.brief"></h6>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                    <span class="roll" @click="rollLeft"></span>
                </div>
               
                <div class="expert" v-if=" this.$i18n.locale == 'en_US'">
                    <span class="roll" @click="rollRight"></span>
                    <div class="expertList">
                        <ul :style="rollStyle" style="display: flex" v-if="figureType === 1">
                            <li v-for="item in expertList1" style="min-width: 220px">
                                <router-link :to="'/figureInfo/' + item.id">
                                    <div class="photo">
                                        <img :src="item.avatar" alt="photo">
                                    </div>
                                    <h3 class="name">{{item.name_en}}</h3>
                                    <h4 class="school">{{item.organization_en}}</h4>
                                    <h6 class="briefing" v-html="item.brief_en"></h6>
                                </router-link>
                            </li>
                        </ul>
                        <ul :style="rollStyle" v-if="figureType === 2">
                            <li v-for="item in expertList2">
                                <router-link :to="'/figureInfo/' + item.id">
                                    <div class="photo">
                                        <img :src="item.avatar" alt="photo">
                                    </div>
                                    <h3 class="name">{{item.name_en}}</h3>
                                    <h4 class="school">{{item.organization_en}}</h4>
                                    <h6 class="briefing" v-html="item.brief_en"></h6>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                    <span class="roll" @click="rollLeft"></span>
                </div>
                
            </div>
        </div>
        
        <div class="news2">
            <div class="container">
                <div class="title">
                    <h2>{{$t('tit.report')}}</h2>
                    <div style="width: 120px;height: 2px;background: #000000;margin: 4px auto 0 auto;"></div>
                </div>
                <div class="link">
                    <router-link to="/report/83">
                        <i>{{$t('Hyperlinks.see')}}</i>
                        <img src="./image/more-next.png" alt="more">
                    </router-link>
                </div>
                <div class="list">
                    <ul>
                        <li v-for="item in reportList" >
                            <router-link :to="{name:'reportInfo',params:{id:item.id}}">
                                <div class="newsImg"><img :src="item.image" alt=""></div>
                               
                            </router-link>
                        </li v>
                    </ul>
                </div>
            </div>
        </div>
        
        <!--
        <div class="feature">
            <div class="container">
                <div class="imgBody left" >
                    <router-link to="/report" class="img-button">
                        查看更多
                    </router-link>
                    
                    <ul  v-if=" this.$i18n.locale == 'zh_CN'" style="margin-left:20px;">
						<li v-for="(item,i) in reportList">
							<router-link :to="{name:'reportInfo',params:{id:item.id}}">
								<div class="newsImg">
									<img :src="item.image" alt="newsImg" style="width:180px;">
								</div>
								<div class="newText">
									<h3 >{{item.name}}</h3>                                
									<p >{{item.brief}}</p>
									
									
								</div>
							</router-link>
						</li>
					</ul>
					
					 <ul  v-if=" this.$i18n.locale == 'en_US'" style="margin-left:20px;">
						<li v-for="(item,i) in reportList">
							<router-link :to="{name:'reportInfo',params:{id:item.id}}">
								<div class="newsImg">
									<img :src="item.image" alt="newsImg">
								</div>
								<div class="newText">
									<h3 >{{item.name}}</h3>
									<p >{{item.brief}}</p>
									
									
								</div>
							</router-link>
						</li>
					</ul>
                            

                </div>
                <div class="imgBody right" >
                    <router-link to="/resources/77" class="img-button">
                        查看更多
                    </router-link>
                    
                    <ul  v-if=" this.$i18n.locale == 'zh_CN'" style="margin-left:20px;">
						<li v-for="(item,i) in resourceList">
							<router-link :to="{name:'reportInfo',params:{id:item.id}}">
								<div class="newsImg">
									<img :src="item.image" alt="newsImg" style="width:180px;">
								</div>
								<div class="newText">
									<h3 >{{item.name}}</h3>                                
									<p >{{item.brief}}</p>
									
									
								</div>
							</router-link>
						</li>
					</ul>
					
					 <ul  v-if=" this.$i18n.locale == 'en_US'" style="margin-left:20px;">
						<li v-for="(item,i) in resourceList">
							<router-link :to="{name:'reportInfo',params:{id:item.id}}">
								<div class="newsImg">
									<img :src="item.image" alt="newsImg">
								</div>
								<div class="newText">
									<h3 >{{item.name}}</h3>
									<p >{{item.brief}}</p>
									
									
								</div>
							</router-link>
						</li>
					</ul>

                </div>
            </div>
        </div>
        -->

        <div class="partners">
            <div class="container">
                <span class="partnerLeft" @click="partnerLeft"></span>
                <div class="more">
                    <router-link to="/partner">{{$t('Hyperlinks.see')}}</router-link>
                    <img src="./image/yy.png" alt="yy">
                </div>
                <div class="title">
                    <h2>{{$t('tit.partners')}}</h2>
                    <div style="width: 120px;height: 2px;background: #ffffff;margin: 4px auto 0 auto;"></div>
                </div>
                <div  class="list">
                    <!--translateX(-1220px)-->
                    <ul :style="jointRoll" id="partners">
                    
                       <!--
                        <li><img src="./image/logo2024/法国气候与环境科学实验室.png" alt=""></li>
                        <li><img src="./image/logo2024/广东省环境科学研究院.png" alt=""></li>
                       
                       
                        <li><img src="./image/logo2024/国家发展和改革委员会能源研究所.png" alt=""></li>
                        <li><img src="./image/logo2024/国务院发展研究中心.png" alt=""></li> 
                        <li><img src="./image/logo2024/河北省环境科学研究院.png" alt=""></li>
                        
                        -->
                        
                        <li><img src="./image/logo9/清华大学.png" alt=""></li>
                        <li><img src="./image/logo5/partner2.png" alt=""></li>
                        <li><img src="./image/logo5/partner1.png" alt=""></li>
                        <li><img src="./image/logo5/partner5.png" alt=""></li>
                        <li><img src="./image/logo2024/上海交通大学.png" alt=""></li>
                        <li><img src="./image/logo2024/南京大学.png" alt=""></li>
                        <li><img src="./image/logo5/partner13.png" alt=""></li>
                    
                        <li><img src="./image/logo5/partner16.png" alt=""></li>
                        <li><img src="./image/logo5/partner22.png" alt=""></li>
                        <li><img src="./image/logo5/partner24.png" alt=""></li>
                        
                        <!--
                        <li><img src="./image/logo2024/美国普林斯顿大学伍德罗·威尔逊公共与国际事务学院.png" alt=""></li> 
                        -->
                      
                        <li><img src="./image/logo2024/清洁交通伙伴关系.png" alt=""></li> 
                       
                       
                        <li><img src="./image/logo2024/生态环境部环境工程评估中心.png" alt=""></li>
                        <li><img src="./image/logo2024/生态环境部环境与经济政策研究中心.png" alt=""></li> 
                        <!--
                        <li><img src="./image/logo2024/世界资源研究所.png" alt=""></li>
                        -->
                        
                        <li><img src="./image/logo2024/中国环境监测总站.png" alt=""></li>
                      
                       
                   
                        <li><img src="./image/logo5/partner6.png" alt=""></li>
                        <li><img src="./image/logo5/partner7.png" alt=""></li>
                        <li><img src="./image/logo5/partner8.png" alt=""></li>
                        <li><img src="./image/logo5/partner9.png" alt=""></li>
                        <li><img src="./image/logo5/partner10.png" alt=""></li>
                     
                      
                        <li><img src="./image/logo5/partner17.png" alt=""></li>
                        <li><img src="./image/logo5/partner18.png" alt=""></li>
                        <li><img src="./image/logo5/partner19.png" alt=""></li>
                        <li><img src="./image/logo5/partner20.png" alt=""></li>
                       
                        
                       
                        
                        <!--
                        <li><img src="./image/logo9/南京大学.png" alt=""></li>
                        <li><img src="./image/logo9/清洁交通伙伴关系.png" alt=""></li>
                        <li><img src="./image/logo9/上海交通大学.png" alt=""></li>
                        <li><img src="./image/logo9/生态环境部环境工程评估中心.png" alt=""></li>
                      	<li><img src="./image/logo9/生态环境部环境与经济政策研究中心.png" alt=""></li>
                        <li><img src="./image/logo9/世界资源研究所.png" alt=""></li>
                        -->
                        
                         <li><img src="./image/logo9/亚洲清洁空气中心.png" alt=""></li>
                         
                        <li><img src="./image/logo9/中国环境监测总站.png" alt=""></li>
                       
                    </ul>
                </div>
                <span class="partnerRight" @click="partnerRight"></span>
            </div>
           
        </div>
        <div class="news">
            <div class="container">
                <div class="title">
                    <h2>{{$t('tit.news')}}</h2>
                    <div style="width: 130px;height: 2px;background: #000000;margin: 4px auto 0 auto;"></div>
                </div>
                <div class="link">
                    <router-link to="/news/70">
                        <i>{{$t('Hyperlinks.see')}}</i>
                        <img src="./image/more-next.png" alt="more">
                    </router-link>
                </div>
                <div class="list">
                    <ul>
                        <li v-for="item in articleList">
                            <router-link :to="{name:'newsInfo',params:{id:item.id}}">
                                <div class="newsImg"><img :src="item.thumb_image" alt=""></div>
                                <div class="newsInfo">
                                    <h2>{{item.name}}</h2>
                                    <b>{{item.release}}</b>
                                </div>
                            </router-link>
                        </li v>
                    </ul>
                </div>
            </div>
        </div>
        
        <MyFooter></MyFooter>
    </div>
</template>

<script>
    import $ from 'jquery'
    import MyHeader from './common/MyHeader'
    import MyFooter from './common/MyFooter'
    import filter from '../filter.js';
    import {createExpert, getExpertList, getExpertDetails, deleteExpert, putExpert} from '@/services/expert';
    import {createArticle, getArticleList, getArticleDetails, deleteArticle, putArticle} from '@/services/article';

    export default {
        name: "index",
        data(){
            return{
                rollStyle:{
                    transform: 'translateX(0)'
                },
                jointRoll:{
                    transform: 'translateX(0)'
                },
                nextStyle:{
                    opacity: 1,
                    display:'block'
                },
                leftButton:'on',
                rightButton:'',
                index:0,
                expertIndex:0,
                pageJson:{
                    page_size:999,
                    page:1,
                    department:1,
                    language:2,
                },
                article:{
                    page_size:4,
                    page:1,
                    category_id:[69,70,71]
                },
                report:{
                    page_size:3,
                    page:1,
                    category_id:[83,84]
                },
                resource:{
                    page_size:1,
                    page:1,
                    category_id:[77]
                },
                expertList1: [],
                expertList2: [],
                articleList:[],
                reportList:[],
                resourceList:[],
                figureType:1
            }
        },
        components: { MyHeader,MyFooter },
        mounted(){
        	if (this.$i18n.locale == "zh_CN") {
        		this.pageJson.language = 2;
        	} else {
        		this.pageJson.language = 3;
        	}	
            for (let i = 1 ;i <= 2 ;i++) {
                this.pageJson.department = i;
                this.getList(res => {
                    let list = res.items;
                    if (i === 1){
                        this.expertList1 = list;
                    } else if (i === 2){
                        this.expertList2 = list;
                    }
                });
            }
            this.getArticleList();
            this.getReportList();
            this.getResourceList();
        },
        methods:{
            getArticleList(){
                getArticleList(this.article).then(res => {
                    let list = res.items;
                    for (let i in list){
                        let item = list[i];
                        item.release = filter.dateFormat(item.release_time, "yyyy-mm-dd");
                    }
                    this.articleList = list;
                }).catch(err => {});
            },
            getReportList(){
            	
                getArticleList(this.report).then(res => {
                    let list = res.items;
                    for (let i in list){
                        let item = list[i];
                        item.release = filter.dateFormat(item.release_time, "yyyy-mm-dd");
                    }
                    this.reportList = list;
                }).catch(err => {});
            },
            getResourceList(){
                getArticleList(this.resource).then(res => {
                    let list = res.items;
                    for (let i in list){
                        let item = list[i];
                        item.release = filter.dateFormat(item.release_time, "yyyy-mm-dd");
                    }
                    this.resourceList = list;
                }).catch(err => {});
            },
            getList(cb){
                getExpertList(this.pageJson).then(res => {
                    if (typeof cb === 'function'){
                        cb(res);
                    }
                }).catch(err => {});
            },
            down(){
                var $body = (window.opera) ? (document.compatMode === "CSS1Compat" ? $('html') : $('body')) : $('html,body');
                $body.animate({scrollTop: 952}, 800);
            },
            rollLeft(){
                let that = this, right = 1135, partnerNum = 0;
                if (this.figureType === 1) {
                    partnerNum = that.expertList1.length;
                } else {
                    partnerNum = that.expertList2.length;
                }
                let rollNUm = Math.ceil(partnerNum/4);
                if (this.expertIndex < (rollNUm - 1)) {
                    this.expertIndex ++;
                    this.rollStyle.transform = `translateX(-${right * this.expertIndex}px)`;
                }
            },
            rollRight(){
                let right = 1135;
                if (this.expertIndex > 0) {
                    this.expertIndex --;
                    this.rollStyle.transform = `translateX(-${right * this.expertIndex}px)`;
                }
            },
            leftRoll(){
                const that = this;
                this.figureType = 1;
                this.expertIndex = 0;
                this.leftButton = 'on';
                this.rightButton = '';
                this.rollStyle['-webkit-transition'] = 'all 0s';
                this.rollStyle.transition = 'all 0s';
                this.rollStyle.transform = 'translateX(0)';
                setTimeout(function () {
                    that.rollStyle['-webkit-transition'] = 'all 0s';
                    that.rollStyle.transition = 'all 0.8s';
                },50);
            },
            rightRoll(){
                const that = this;
                this.figureType = 2;
                this.expertIndex = 0;
                this.leftButton = '';
                this.rightButton = 'on';
                this.rollStyle['-webkit-transition'] = 'all 0s';
                this.rollStyle.transition = 'all 0s';
                this.rollStyle.transform = 'translateX(0)';
                setTimeout(function () {
                    that.rollStyle['-webkit-transition'] = 'all 0s';
                    that.rollStyle.transition = 'all 0.8s';
                },50);
            },
            partnerRight(){
                let that = this, right = 1220;
                let partnerNum = $('#partners li').length;
                let rollNUm = Math.ceil(partnerNum/5);
                if (this.index < (rollNUm - 1)) {
                    this.index ++;
                    this.jointRoll.transform = `translateX(-${right * this.index}px)`;
                }
            },
            partnerLeft(){
                let right = 1220;
                if (this.index > 0) {
                    this.index --;
                    this.jointRoll.transform = `translateX(-${right * this.index}px)`;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>


    .carousel-caption{
    
    	position: absolute;
		right: 15%;
		bottom: 1.25rem;
		left: 5%;
		padding-top: 1.25rem;
		padding-bottom: 4.25rem;
		color: #fff;
		text-align: center;
    }
       
        
        
    .main{
        .banner{
            width: 100%;
            height: 814px;
            background: url("./image/banner.png") no-repeat center center;
            background-size: cover;
            position: relative;
            .txt{
                position: absolute;
                left:225px;
                top: 350px;
                p{
                    color:white;
                }
                .ch{
                    font-size: 46px;
                }
                .en{
                    font-size: 30px;
                    margin-top: 10px;
                }
            }
            .down{
                cursor: pointer;
                position: absolute;
                bottom: 0;
                left: 50%;
                transform: translate(-50%,50%);
            }
        }
        .purpose{
            margin-top: 80px;
            .bigTitle{
                width:500px;
                height:95px;
                margin: 0 auto;
                background: url("./image/our mission.png") no-repeat center center ;
                background-size: 100% ;
                h2{
                    color: #304656;
                    font-weight:bold;
                    font-size:28px;
                    line-height: 38px;
                    height: 38px;
                    padding-top: 52px;
                    text-align: center;
                }
            }
            .describe{
                width:534px;
                margin: 20px auto 0;
                font-size:14px;
                color: #999999;
                line-height:25px;
                text-align: center;
            }
            .button{
                text-align: center;
                margin: 40px 0;
                a{
                    display: inline-block;
                    width: 98px;
                    height: 38px;
                    line-height: 38px;
                    text-align: center;
                    color: #666666;
                    font-size:14px;
                    border: 1px solid #E0E0E0;
                }
                .on{
                    background-color: #13AE67;
                    border: 1px solid #13AE67;
                    color: #FFFFFF;
                }
            }
            .expert{
                width: 100%;
                position: relative;
                padding-bottom:50px;
                .roll{
                    transition: all .8s;
                    cursor: pointer;
                    width: 47px;
                    height: 47px;
                    display: block;
                    background: url("./image/left.png") no-repeat center center;
                    background-size: 100% 100%;
                    position: absolute;
                    z-index: 20;
                    right:0;
                    top: 95px;
                    transform: translate(0,-50%);
                    &:nth-of-type(1){
                        background: url("./image/right.png") no-repeat center center;
                        left: 0;
                    }
                }
                .expertList{
                    width: 1072px;
                    margin: 60px auto 0;
                    overflow: hidden;
                    ul{
                        transition: all .8s;
                        white-space: nowrap;
                        li{
                            float: none;
                            display: inline-block;
                            width:220px;
                            margin-right: 64px;
                            &:last-child{
                                margin-right: 0;
                            }
                            .photo{
                                margin: 0 auto;
                                width:190px;
                                height:190px;
                                border-radius: 50%;
                                overflow: hidden;
                                img{
                                    width: 100%;
                                }
                            }
                            .name{
                                width: 100%;
                                text-align: center;
                                color: #001951;
                                margin-top: 12px;
                                height:24px;
                                line-height:24px;
                                font-weight:bold;
                            }
                            .school{
                                text-align: center;
                                font-size:12px;
                                width: 100%;
                                margin-top: 8px;
                                color: #666666;
                                height:16px;
                                line-height:16px;
                                white-space:nowrap;
                                overflow:hidden;
                                text-overflow: ellipsis;
                            }
                            .briefing{
                                margin-top: 8px;
                                text-align: left;
                                font-weight:bold;
                                width: 100%;
                                color: #666666;
                                font-size: 12px;
                                line-height:16px;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 2;
                                overflow: hidden;
                                white-space: normal;
                            }
                        }
                    }
                }
            }

        }
        .partners{
            margin-top: 64px;
            background-image: linear-gradient(-223deg, #00A0E9 0%, #13AE67 100%);
            background-size: cover;
            height: 280px;
            .container{
                position: relative;
                .more{
                    position: absolute;
                    overflow: hidden;
                    top: 50px;
                    right: 0;
                    a{
                        font-size: 14px;
                        line-height: 20px;
                        height: 20px;
                        display: block;
                        float: left;
                        color: #fff;
                    }
                    img{
                        cursor: pointer;
                        float: left;
                        width: 20px;
                    }
                }
                .title{
                    h2{
                        font-size: 28px;
                        line-height: 38px;
                        height: 38px;
                        margin-top: 32px;
                        text-align: center;
                        color: #FFFFFF;
                        letter-spacing: 0;
                        font-weight: bold;
                    }
                }
                .list{
                    width: 1086px;
                    margin: 55px auto 0;
                    overflow: hidden;
                    ul{
                        white-space: nowrap;
                        transition: all .8s;
                        li{
                            float: none;
                            display: inline-block;
                            margin-right: 134px;
                            &:last-child{
                                margin-right:0;
                            }
                            img{
                                width: 110px;
                            }
                        }
                    }

                }
                .partnerLeft{
                    left: 0;
                    transition: all .3s;
                    background: url("./image/zz.png") no-repeat center center;
                    background-size: 100% 100%;
                    &:hover{
                        background: url("./image/zz-on.png") no-repeat center center;
                    }
                    bottom:44px;
                }
                .partnerRight{
                    right: 0;
                    transition: all .3s;
                    background: url("./image/yy.png") no-repeat center center;
                    background-size: 100% 100%;
                    &:hover{
                        background: url("./image/yy-on.png") no-repeat center center;
                    }
                    bottom:44px;
                }
                span{
                    position: absolute;
                    bottom: 32px;
                    display: block;
                    width: 44px;
                    height: 44px;
                }
            }
        }
        .news{
            padding: 42px 0 88px;
            background: #F4F4F4;
            .container{
                overflow: visible;
                .title{
                    h2{
                        text-align: center;
                        font-size: 28px;
                        color: #304656;
                        font-weight:bold;
                        height: 38px;
                        line-height: 38px;
                    }
                }
                .link{
                    width: 100%;
                    margin-top: 10px;
                    overflow: hidden;
                    a{
                        display: block;
                        float: right;
                        overflow: hidden;
                        i{
                            float: left;
                            color: #13AE67;
                            display: block;
                            height: 20px;
                            line-height: 20px;
                            font-size: 14px;
                        }
                        img{
                            margin-left: 9px;
                            margin-top: 5px;
                            float: left;
                        }
                    }
                }
                .list{
                    width: 100%;
                    margin-top: 35px;
                    ul{
                       	width: 70vw;
            			margin: 0 auto;
            			display: flex;
                        padding-left: 0rem;
                        li{
                            width:100%;
                            margin-right: 40px;
                            transition: all 0.3s;
                            &:hover{
                                box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);
                                .newsInfo{
                                    h2{
                                        color: #09A7A9;
                                    }
                                }
                            }
                            &:last-child{
                                margin-right: 0;
                            }
                            .newsImg{
                                width: 100%;
                               
                                overflow: hidden;
                                img{
                                    width: 100%;
                                }
                            }
                            .newsInfo{
                                width: 100%;
                                background: #fff;
                                padding: 16px 0;
                                h2{
                                    padding: 0 10px;
                                    margin: 0 auto;
                                    color: #333333;
                                    font-size:14px;
                                    font-weight:600;
                                    line-height:20px;
                                    transition: all 0.3s;

                                }
                                b{
                                    display: block;
                                   padding: 0 10px;
                                    margin: 12px auto 0;
                                    color: #999999;
                                    font-size: 12px;
                                    height: 16px;
                                    line-height: 16px;
                                }
                            }
                        }
                    }
                }
            }
        }
         .news2{
            padding: 42px 0 88px;
            background: #F4F4F4;
            .container{
                overflow: visible;
                .title{
                    h2{
                        text-align: center;
                        font-size: 28px;
                        color: #304656;
                        font-weight:bold;
                        height: 38px;
                        line-height: 38px;
                    }
                }
                .link{
                    width: 100%;
                    margin-top: 10px;
                    overflow: hidden;
                    a{
                        display: block;
                        float: right;
                        overflow: hidden;
                        i{
                            float: left;
                            color: #13AE67;
                            display: block;
                            height: 20px;
                            line-height: 20px;
                            font-size: 14px;
                        }
                        img{
                            margin-left: 9px;
                            margin-top: 5px;
                            float: left;
                        }
                    }
                }
                .list{
                    width: 100%;
                    margin-top: 35px;
                    ul{
                    	width: 70vw;
            			margin: 0 auto;
            			display: flex;
                     
                    
                        padding-left: 0rem;
                        li{
                            
                            width:100%;
                            margin-right: 56px;
                            transition: all 0.3s;
                            &:hover{
                                box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);
                                .newsInfo{
                                    h2{
                                        color: #09A7A9;
                                    }
                                }
                            }
                            &:last-child{
                                margin-right: 0;
                            }
                            .newsImg{
                                width: 100%;
                               border-radius: 10px;
                                overflow: hidden;
                                img{
                                    width: 100%;
                                }
                            }
                           
                            .newsInfo{
                                width: 100%;
                                background: #fff;
                                padding: 16px 0;
                                h2{
                                    width:230px;
                                    margin: 0 auto;
                                    color: #333333;
                                    font-size:14px;
                                    font-weight:600;
                                    line-height:20px;
                                    transition: all 0.3s;

                                }
                                b{
                                    display: block;
                                    width:230px;
                                    margin: 12px auto 0;
                                    color: #999999;
                                    font-size: 12px;
                                    height: 16px;
                                    line-height: 16px;
                                }
                            }
                        }
                    }
                }
            }
        }
        .feature{
            padding-top: 40px;
            padding-bottom: 48px;
           
            .container{
                overflow: hidden;
                .imgBody{
                    width: 575px;
                    height: 323px;
                    img{
                        width: 100%;
                    }
                   
                }
                .left{
                    float: left;
                    background: url(./image/feature1.png) no-repeat 100%;
                    text-align: right;
                    .img-button {
                    	border: 1px solid white;
                    	padding: 2px 4px;
                    	color: white;
                    	display: inline-block;
                    	margin: 20px;

                    }
                }
                .right{
                    float: right;
                    background: url(./image/feature2.png) no-repeat 100%;
                    text-align: right;
                    .img-button {
                    	border: 1px solid white;
                    	padding: 2px 4px;
                    	color: white;
                    	display: inline-block;
                    	margin: 20px;

                    }
                }
                
                ul{
					li{
						margin-bottom: 40px;
						&:last-child{
							margin-bottom: 32px;
						}
						a{
							overflow: hidden;
							display: flex;
							.newsImg{
								img{
									width: 216px;
								}
							}
							.newText{
							margin-left: 20px;
							text-align:left;
							margin-right:15px;
							flex:1;
								h3{
									margin-top: 0px;
									
									color: #ffffff;
									height:24px;
									font-size:18px;
									font-weight:bold;
									line-height:24px;
								}
								p{
									display: block;
									font-size: 14px;
									color: #ffff00;
									line-height: 20px;
									height: 60px;
									margin-top: 22px;
									display: -webkit-box;
									-webkit-box-orient: vertical;
									-webkit-line-clamp: 3;
									overflow: hidden;
									margin-top: 35px;
								}
								h6{
									margin-top: 22px;
									height:12px;
									font-size:12px;
									color:#A0A0A0;
									line-height:12px;
								}
							}
						}
					}
				}

            }
        }
    }

</style>
